export default "__VITE_ASSET__FQKdNzgU__"